import qs from 'qs';

/**
 * Util to validate if object has any empty properties
 */
export const hasEmptyProperties = (obj: Record<string, unknown>) => {
    return Object.entries(obj).some(([, val]) => val === '' || val === null || val === undefined);
};

/**
 * Util to extract params from a URL takes a callback
 * which executes after parsing with query as argument
 *
 * Pass compare query to avoid callback execution if queries are alike
 */
export const getUrlQuery = (
    path: string,
    callback: (query: string) => string,
    compareQuery?: string
) => {
    const indexOfUrlQuery = path.indexOf('?');
    if (indexOfUrlQuery > -1) {
        const urlQuery = path.slice(indexOfUrlQuery);
        const params = qs.parse(urlQuery.slice(1));
        if (
            (!compareQuery && params.query) ||
            (compareQuery && params.query && params.query !== compareQuery)
        ) {
            return callback(params.query.toString() || '');
        }
    }

    return '';
};
